export type UserNavAccess =
	| {
			access_companies?: boolean;
			access_contacts?: boolean;
			access_ucc?: boolean;
	  }
	| null
	| undefined;

export function getDefaultRoute(user: UserNavAccess): string {
	if (user?.access_companies) return "/companies";
	if (user?.access_ucc) return "/ucc";
	return "/enrichment";
}
